import { createSelector } from "reselect";

const employees = (state) => state.administration.employees;

export const loading = createSelector(employees, (state) => state.loading);

export const loadingAction = createSelector(
  employees,
  (state) => state.loadingAction
);

export const data = createSelector(employees, (state) => state.data);

export const pagination = createSelector(
  employees,
  (state) => state.pagination
);

export const detail = createSelector(employees, (state) => state.detail);
